import { render, staticRenderFns } from "./DonorOtherLabs.vue?vue&type=template&id=29363a86"
import script from "./DonorOtherLabs.vue?vue&type=script&lang=js"
export * from "./DonorOtherLabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports